

import React, { memo } from 'react';
import cx from 'classnames';

import Text from '../../../../Text';
import Icon from '../../../../Icon';
import { EMPTY_DATA } from '../styles/emptyDataPlaceholder';
import '../styles/_emptyDataPlaceholder.scss';







const EmptyDataPlaceholder = ({
  isMobile,
  customSearchText = '',
  searchTerm = ''
}) =>
<div className={cx(EMPTY_DATA, 'empty-data-container', { 'empty-data-container--mobile': isMobile })}>
    <Icon name="search" size={40} color="regent" />
    <Text heading3 centered noMargin="bottom">{`Sorry we couldn't find any matches${searchTerm || customSearchText ? ' for' : ''}`}</Text>
    {(searchTerm || customSearchText) &&
  <Text centered className="empty-data-container__search-term" heading3>
        {`'${customSearchText || searchTerm}'`}
      </Text>}

    <Text placeholder centered>
      {'Try adjusting your search or filters to find what you\'re looking for.'}
    </Text>
  </div>;


export default memo(EmptyDataPlaceholder);